// extracted by mini-css-extract-plugin
export default {"root":"NotFound_root__nyuAu","titleWrap":"NotFound_titleWrap__c9W7x"};